import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetEmailSequenceContext as GetEmailSequenceContextQuery} from 'nutshell-graphql-types';

import {generateContextString} from '../../helpers';

import GET_SALES_PROCESS_CONTEXT from '../queries/get-email-sequence-context.graphql';

export const useGetEmailSequenceContext = (): {
    context: string | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetEmailSequenceContextQuery,
        Record<any, any>
    >(GET_SALES_PROCESS_CONTEXT, {});

    return {
        context: generateContextString(data),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
